import React from "react";

export const Logos = () => {
  const licencesData = [
    {
      title: "Malta",
      url: "https://everymatrix.com/gambling-licences/malta-gambling-licences/",
      imgSrc:
        "https://everymatrix.com/wp-content/uploads/2019/03/mga-logo1.png",
    },
    {
      title: "Great Britain",
      url: "https://everymatrix.com/gambling-licences/the-united-kingdom-gambling-licences/",
      imgSrc: "https://everymatrix.com/wp-content/uploads/2019/03/gambling.png",
    },
    {
      title: "Romania",
      url: "https://everymatrix.com/gambling-licences/romania-gambling-licence/",
      imgSrc: "https://everymatrix.com/wp-content/uploads/2019/03/onjn.png",
    },
    {
      title: "Greece",
      url: "https://everymatrix.com/gambling-licences/greece-gambling-licence/",
      imgSrc:
        "https://everymatrix.com/wp-content/uploads/2021/10/eeep-logo-en-1.png",
    },
    {
      title: "Sweden",
      url: "https://everymatrix.com/gambling-licences/swedish-gambling-licence/",
      imgSrc:
        "https://everymatrix.com/wp-content/uploads/2023/03/logo-sweden-licence.png",
    },
    {
      title: "Denmark",
      url: "https://everymatrix.com/gambling-licences/denmark-gambling-licence/",
      imgSrc: "https://everymatrix.com/wp-content/uploads/2019/03/denmark.svg",
    },
  ];
  return (
    <>
      <section className="our-licences py-5" id="explore">
        <div className="container container_custom">
          <div className="row">
            <div className="col-md-12">
              <div className="inner">
                <ul className="d-flex flex-wrap list-unstyled justify-content-center gap-4">
                  {licencesData.map((licence, index) => (
                    <li key={index}>
                      <a
                        // href={licence.url}
                        title={licence.title}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {licence.imgSrc ? (
                          <img
                            src={licence.imgSrc}
                            alt={licence.title}
                            style={{ maxWidth: "120px", height: "auto" }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "120px",
                              height: "60px",
                              backgroundColor: "#eee",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: "12px",
                              color: "#555",
                              borderRadius: "4px",
                            }}
                          >
                            {licence.title}
                          </div>
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
